// extracted by mini-css-extract-plugin
export default {"watchlistContainer":"Watchlist_watchlistContainer__gWdgB","popupScreen":"Watchlist_popupScreen__EAY1+","popupScreenAlert":"Watchlist_popupScreenAlert__CAkJW"};